import { useDataSubmit, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let task_id = useDataValue({
    context: 'task',
    path: 'id',
    viewPath: props.viewPath,
  })

  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'open_task_overlay',
      task_id,
    })
  }
}
